import { loadGIFQuality, loadGIFSound } from "utils/storage";

const getDefaultQuality = (): string => {
  const query = new URLSearchParams(window.location.search);

  if (query.get("from") === "embed") {
    return "hd";
  }

  return "sd";
};

export enum authModalTabs {
  login="login",
  signup="signup",
}

export interface IApplicationState {
    isBurgerMenuOpen: boolean;
    isProfileMenuOpen: boolean;
    isSearchBarOpen: boolean;
    serverResponse: string | null;
    serverError: Error | null;
    gifQuality: string;
    gifSound: boolean;
    authModal: {
      show: boolean;
      tab: authModalTabs;
    };
}

const defaultState: IApplicationState = {
  isBurgerMenuOpen: false,
  isProfileMenuOpen: false,
  isSearchBarOpen: false,
  serverResponse: null,
  serverError: null,
  gifQuality: loadGIFQuality() || getDefaultQuality(),
  gifSound: loadGIFSound() || false,
  authModal: {
    show: false,
    tab: authModalTabs.login
  }
};

export const getDefaultApplicationState = () => defaultState;
